import React, { useState } from "react";
import { personalInfo } from "../data";
import { Mail, Phone } from "lucide-react";
import { SiGithub, SiLinkedin } from "react-icons/si";
import "./PageStyles.css";

const ContactPage = () => {
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });
  const [formStatus, setFormStatus] = useState({ state: "idle", message: "" });
  // API base URL
  // For production (Vercel): uses /api (relative path, same domain)
  // For development: uses local backend server
  const apiBase = process.env.REACT_APP_API_BASE_URL || 
    (window.location.hostname === 'localhost' ? 'http://localhost:5000' : '/api');

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!apiBase) {
      setFormStatus({
        state: "error",
        message: "Backend API URL not configured. Please set REACT_APP_API_BASE_URL in environment variables.",
      });
      return;
    }
    
    const sendMessage = async () => {
      setFormStatus({ state: "loading", message: "" });
      try {
        const res = await fetch(`${apiBase}/api/contact`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        });

        if (!res.ok) {
          const error = await res.json().catch(() => ({}));
          throw new Error(error?.error || "Unable to send message");
        }

        setFormStatus({ state: "success", message: "Thanks! Your message was sent." });
        setFormData({ name: "", email: "", message: "" });
      } catch (error) {
        setFormStatus({
          state: "error",
          message: error.message || "Something went wrong. Please try again.",
        });
      }
    };

    sendMessage();
  };

  return (
    <div className="page">
      <header className="page-header">
        <h1 className="section-title">Get In Touch</h1>
        <p className="page-lead">Reach out for projects, collaborations, or opportunities.</p>
      </header>
      <section className="section section-dark">
        <div className="container">
          <div className="contact-content">
            <div className="contact-info">
              <h3 className="contact-subtitle">Let's Connect</h3>
              <p className="contact-text">
                I'm always open to discussing new projects, creative ideas, or opportunities
                to be part of your vision. Feel free to reach out!
              </p>
              <div className="contact-links">
                <a href={`mailto:${personalInfo.email}`} className="contact-link">
                  <Mail size={24} />
                  <span>{personalInfo.email}</span>
                </a>
                <a href={`tel:${personalInfo.phone}`} className="contact-link">
                  <Phone size={24} />
                  <span>{personalInfo.phone}</span>
                </a>
                <a href={personalInfo.linkedin} target="_blank" rel="noopener noreferrer" className="contact-link">
                  <SiLinkedin size={24} />
                  <span>LinkedIn Profile</span>
                </a>
                <a href={personalInfo.github} target="_blank" rel="noopener noreferrer" className="contact-link">
                  <SiGithub size={24} />
                  <span>GitHub Profile</span>
                </a>
              </div>
            </div>
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <input
                  type="text"
                  placeholder="Your Name"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  required
                  className="form-input"
                />
              </div>
              <div className="form-group">
                <input
                  type="email"
                  placeholder="Your Email"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  required
                  className="form-input"
                />
              </div>
              <div className="form-group">
                <textarea
                  placeholder="Your Message"
                  value={formData.message}
                  onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                  required
                  rows="5"
                  className="form-textarea"
                ></textarea>
              </div>
              <button type="submit" className="btn-primary btn-full" disabled={formStatus.state === "loading"}>
                {formStatus.state === "loading" ? "Sending..." : "Send Message"}
              </button>
              {formStatus.state === "success" && (
                <p className="form-success">{formStatus.message}</p>
              )}
              {formStatus.state === "error" && (
                <p className="form-error">{formStatus.message}</p>
              )}
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;

